<!-- « Ton climat : océanique tempéré (Grâce-Hollogne) » : le chevron ouvre le choix du climat. -->
<button type="button" data-testid="climate-banner-trigger" class="flex w-full items-start gap-2 min-h-target py-1 text-left text-body-s text-vw-ink"
  (click)="pickerClick.emit()">
  <svg class="mt-0.5 h-4 w-4 shrink-0 text-vw-ink" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
  </svg>
  <span class="grow min-w-0">
    @if (selectedClimateType) {
      {{ 'calendar.climate.other' | translate }} <b class="font-semibold">{{ 'profile.addresses.climate-types.' + selectedClimateType | translate }}</b>
    } @else if (myClimateType) {
      {{ 'calendar.climate.myClimate' | translate }} : <b class="font-semibold">{{ 'profile.addresses.climate-types.' + myClimateType | translate | lowercase }}</b>@if (city) { ({{ city }})}
    } @else {
      {{ 'calendar.climate.myClimate' | translate }}
    }
  </span>
  <svg xmlns="http://www.w3.org/2000/svg" class="mt-0.5 w-4 h-4 text-vw-muted shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
</button>
